// Stores and retrieves values, including objects, from persistent
// local storage. Implementation uses "localStorage" and JSON
// encoding.

export default class PersistentStorage {
  static set(name, value) {
    // Encode and store in localStorage
    localStorage.setItem(name, JSON.stringify(value));
  }
  
  static get(name) {
    // Decode and return from localStorage
    // If data is not valid JSON, return false
    try {
      const retval = JSON.parse(localStorage.getItem(name));
      return retval;
    } catch (e) {
      // console.warn(e);
      return false;
    }
  }
  
  static remove(name) {
    localStorage.removeItem(name);
  }
}
